type Mode = "live" | "test"

type SubscriptionStatus = "active" | "paused" | "canceled" | "none"

type PurchaseStatus = "active" | "expired"

type Store = "Stripe" | "Paypal"

type Duration = "oneYear"

type PlanType = "Annual" | "1 Year" | "Lifetime"

interface Plan {
  type: "pro" | "lifetime"
  plan: "oneYear" | "lifetime"
  nickname: "1 Year" | "Lifetime"
  description: "Angle 4" | "Angle Lifetime"
}

export interface Plans {
  [key: string]: Plan
}

export interface Pricing {
  oneYear: {
    price: number
    discount: number
  }
  lifetime: {
    price: number
    discount: number
  }
}

export interface AccountStatus {
  isAdmin: boolean
  isProUser: boolean
  isFreeUser: boolean

  subscription?: Subscription
  subscribed: boolean
  isSubscriptionEffective: boolean
  purchase?: Purchase
  purchased: boolean
  isPurchaseEffective: boolean
  accessEndDate?: Date
  subscriptionCase: SubscriptionCase

  seats?: Array<Seat>
  seated: boolean
  seatOwner?: string

  store: Store
}

export enum SubscriptionCase {
  free = "free",
  subscriptionActive = "subscriptionActive",
  subscriptionPaused = "subscriptionPaused",
  subscriptionCancelled = "subscriptionCancelled",
  purchaseActive = "purchaseActive",
  purchaseExpired = "purchaseExpired",
  admin = "admin",
  undetermined = "undetermined",
}

interface Subscription {
  subscriptionId: string
  userId: string
  status: SubscriptionStatus
  seatQuantity: number
  amount: number
  startDate: Date
  currentPeriodStart?: Date
  currentPeriodEnd?: Date
  canceledDate?: Date
  endDate?: Date

  planId: string
  planName: string
  duration: string
  mode?: Mode

  createdAt: Date
}

interface Seat {
  seatId?: string
  userId: string
  ownerUserId: string
  subscriptionId?: string
  purchaseId?: string
  mode?: Mode
  createdAt: Date
}

interface Purchase {
  purchaseId?: string
  userId: string
  status: PurchaseStatus
  amount?: number
  date: Date
  startDate: Date
  endDate: Date
  version: number
  duration: Duration
  mode?: Mode

  code?: string
  legacyCustomerId?: string

  createdAt: Date
}
